import { Textsms } from "@mui/icons-material";
import UserMenuItem from "./UserMenuItem";
import { FC, useRef } from "react";
import FeedbackDialog from "./FeedbackDialog";
import { DialogHandle } from "../Dialog/DialogTypes";

const FeedbackItem: FC<object> = () => {
  const feedbackDialog = useRef<DialogHandle>(null);
  function showFeedback() {
    feedbackDialog.current?.show();
  }
  return (
    <>
      <UserMenuItem Icon={Textsms} onClick={showFeedback}>
        Feedback
      </UserMenuItem>
      <FeedbackDialog ref={feedbackDialog} />
    </>
  );
};

export default FeedbackItem;
